<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách KPI tạm tính</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Serial/email MC/Hợp đồng"
              v-model="paramsFilter.textSearch"
            />
          </div>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Tháng KPI"
              v-model="paramsFilter.monthlyKpi"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="paramsFilter.saleId" :options="optionSaleIds" placeholder="CVKD">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="paramsFilter.type" :options="optionType" placeholder="Tình trạng">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="paramsFilter.refer" :options="optionSource" placeholder="Nguồn tạo">
            </Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              class="btn btn-primary hc-37 mr-2 pt-2"
              @click.prevent="submitSearchForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              @click.prevent="clearSearch"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng:
            <strong class="text-primary">{{ totalKpi }}</strong>
            <b-table
              class="mt-1"
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataKpiLists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #head(index)>
                <div class="text-center">STT</div>
              </template>

              <template #cell(index)="data">
                <div class="text-center">{{ data.index + 1 }}</div>
              </template>

              <template #cell(typeService)="data">
                <div class="text-center">
                  {{ data.item.typeService | serviceType }}
                </div>
              </template>

              <template #cell(merchant)="data">
                <div>Email: {{ data.item.mcEmail }}</div>
                <div>
                  Loại MC:
                  {{
                    data.item.typeMc
                      ? joinArrayData(data.item.typeMc, optionMcKeyLvl)
                      : data.item.typeMc
                  }}
                </div>
                <div>
                  Tình trạng:
                  {{
                    data.item.statusMc
                      ? joinArrayData(data.item.statusMc, optionMCLock)
                      : data.item.statusMc
                  }}
                </div>
              </template>

              <template #cell(contractCode)="data">
                <div>Mã hợp đồng: {{ data.item.contractCode }}</div>
                <div>Mã phụ lục: {{ data.item.appendixCode }}</div>
              </template>

              <template #cell(serial)="data">
                <div>Tên: {{ data.item.service }}</div>
                <div>Serial: {{ data.item.serial }}</div>
              </template>

              <template #cell(price)="data">
                <div>{{ data.item.price | formatNum }}</div>
              </template>

              <template #cell(time)="data">
                <div>Tạo: {{ data.item.createdTime | formatDate }}</div>
                <div>Sửa: {{ data.item.modifiedTime | formatDate }}</div>
              </template>

              <template #cell(packageService)="data">
                <div>
                  Tên gói:
                  {{
                    data.item.packageService
                      ? joinArrayData(data.item.packageService, optionTypeContractPackage)
                      : ''
                  }}
                </div>
                <div>Thời hạn: {{ data.item.duration ? data.item.duration + ' năm' : '' }}</div>
              </template>

              <template #cell(refer)="data">
                <div>
                  {{
                    data.item.refer ? joinArrayData(data.item.refer, optionSource) : data.item.refer
                  }}
                </div>
              </template>

              <template #cell(stt)="data">
                <div class="text-center">{{ data.item.index }}</div>
              </template>

              <template #cell(numberKpi)="data">
                <div class="text-center">{{ data.item.numberKpi }}</div>
              </template>

              <template #cell(actionKpi)="data">
                <div class="text-center">
                  {{ data.item.actionKpi ? getDisplayActionKpi(data.item.actionKpi) : '' }}
                </div>
              </template>

              <template #cell(ratioKpi)="data">
                <div class="text-center">{{ data.item.ratioKpi ? data.item.ratioKpi : 0 }}%</div>
              </template>

              <template #cell(sale)="data">
                <div class="text-bold">Tên: {{ data.item.saleName }}</div>
                <div class="text-bold">Email: {{ data.item.saleEmail }}</div>
              </template>

              <template #cell(reasonKpiFail)="data">
                <div class="text-center">
                  {{ data.item.reasonKpiFail ? data.item.reasonKpiFail : '' }}
                </div>
              </template>

              <template #cell(type)="data">
                <div :class="getColorType(data.item.type) + ' badge text-center'">
                  {{ data.item.type ? joinArrayData(data.item.type, optionType) : data.item.type }}
                </div>
              </template>
              <template #cell(action)="data">
                <div class="text-center">
                  <b-dropdown
                    variant="outline-light"
                    v-if="displayActionFollowType.includes(data.item.type)"
                  >
                    <b-dropdown-item class="dropdown-item" @click="openCancelModel(data.item.id)"
                      >Hủy KPI
                    </b-dropdown-item>
                    <b-dropdown-item class="dropdown-item" @click="openChangeMonthModel(data.item)"
                      >Chuyển tháng tính KPI
                    </b-dropdown-item>
                    <b-dropdown-item class="dropdown-item" @click="openRecalculateModel(data.item)"
                      >Tính lại KPI
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <VueLoadingOverlay :active.sync="loading" :is-full-page="true"></VueLoadingOverlay>
        <div class="pagination-bottom">
          <b-pagination
            class="mr-2 fl-right"
            v-model="paramsFilter.page"
            :total-rows="totalKpi"
            :per-page="paramsFilter.limit"
          >
          </b-pagination>
        </div>
      </div>
      <b-modal id="modal-scoped" v-model="cancelModel">
        <template #modal-header="{ close }">
          <h5>Hủy KPI</h5>
          <b-button size="sm" variant="light" @click="close()"> x </b-button>
        </template>
        <b-form-group>
          <label class="text-bold">Lý do hủy<span class="text-red">(*)</span></label>
          <b-form-input v-model="cancelItem.note"></b-form-input>
        </b-form-group>
        <p class="text-danger" v-show="cancelMess">
          <i class="bx bx-error-alt"></i> {{ cancelMess }}
        </p>
        <template #modal-footer="{ cancel }">
          <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
          <b-button variant="primary" @click="clickCancelKpi()"> Lưu </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-scoped" v-model="changeMonthModel">
        <template #modal-header="{ close }">
          <h5>Chuyển tháng tính KPI</h5>
          <b-button size="sm" variant="light" @click="close()"> x </b-button>
        </template>
        <p class="mb-2">
          <label class="text-bold">Tháng tính kpi hiện tại:</label>
          {{ changeMonthItemSelect.monthlyKpi }}
        </p>
        <b-form-group>
          <label class="text-bold">Lý do chuyển<span class="text-red">(*)</span></label>
          <b-form-input v-model="changeMonthItem.description"></b-form-input>
        </b-form-group>
        <b-form-group>
          <label class="text-bold">Chuyển đến tháng<span class="text-red">(*)</span></label>
          <month-picker-input v-model="objMonthlyKpi" :months="months"></month-picker-input>
        </b-form-group>
        <p class="text-danger" v-show="changeMonthMess">
          <i class="bx bx-error-alt"></i> {{ changeMonthMess }}
        </p>
        <template #modal-footer="{ cancel }">
          <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
          <b-button variant="primary" @click="clickChangeMonthKpi()"> Lưu </b-button>
        </template>
      </b-modal>
      <b-modal id="modal-scoped" v-model="recalculateModel">
        <template #modal-header="{ close }">
          <h5>Tính lại KPI</h5>
          <b-button size="sm" variant="light" @click="close()"> x </b-button>
        </template>
        <p class="mb-2">
          <label class="text-bold">Merchant:</label> {{ recalculateItemSelect.mcEmail }}
        </p>
        <p class="mb-2">
          <label class="text-bold">Tháng:</label> {{ recalculateItemSelect.monthlyKpi }}
        </p>
        <p class="mb-2">
          <label class="text-bold">CVKD:</label> {{ recalculateItemSelect.saleEmail }}
        </p>
        <b-form-group>
          <label class="text-bold">Lý do tính lại<span class="text-red">(*)</span></label>
          <b-form-input v-model="recalculateItem.reason"></b-form-input>
        </b-form-group>
        <p class="text-danger" v-show="recalculateMess">
          <i class="bx bx-error-alt"></i> {{ recalculateMess }}
        </p>
        <template #modal-footer="{ cancel }">
          <b-button variant="light" @click="cancel()"> Bỏ qua </b-button>
          <b-button variant="primary" @click="clickRecalculateKpi()"> Tính lại </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
  import { KpiSaleOrderService } from '@/services/kpi.sale.order.service'
  import Config from '@/thirdParty/config'
  import { MonthPickerInput } from 'vue-month-picker'
  import { StaffService } from '@/services/staff.service'

  const fieldsTable = [
    { key: 'index', label: 'STT' },
    { key: 'typeService', label: 'Loại dịch vụ' },
    { key: 'service', label: 'Dịch vụ' },
    { key: 'merchant', label: 'Merchant' },
    { key: 'contractCode', label: 'Mã hợp đồng/Mã phụ lục' },
    { key: 'receiptCode', label: 'Mã phiếu thu' },
    { key: 'serial', label: 'Thiết bị' },
    { key: 'price', label: 'Giá tiền' },
    { key: 'time', label: 'Thời gian' },
    { key: 'packageService', label: 'Loại gói & Thời hạn' },
    { key: 'actionKpi', label: 'Loại' },
    { key: 'refer', label: 'Nguồn MC' },
    { key: 'stt', label: 'STT thiết bị đã mua' },
    { key: 'numberKpi', label: 'KPI tạm tính' },
    { key: 'ratioKpi', label: '% KPI' },
    { key: 'monthlyKpi', label: 'Tháng tính KPI' },
    { key: 'sale', label: 'CVKD' },
    { key: 'description', label: 'Ghi chú' },
    { key: 'reasonKpiFail', label: 'Mô tả lỗi' },
    { key: 'type', label: 'Tình trạng' },
    { key: 'action', label: 'Thao tác' },
  ]

  export default {
    components: {
      MonthPickerInput,
    },
    data() {
      return {
        loading: false,
        fieldsTable,
        filterTable: fieldsTable,
        dataKpiLists: [],
        optionSource: [
          { id: 'SALES', text: 'Sales' },
          { id: 'AGENCY', text: 'Cộng tác viên' },
          { id: 'MARKETING', text: 'Marketing' },
          { id: 'AFTER_SALE', text: 'After Sale' },
          { id: 'TELESALE', text: 'Telesale' },
          { id: 'OP_AFTER_SALE', text: 'Vận hành CSKH tạo' },
        ],
        optionMcKeyLvl: Config.mcKeyLvl,
        optionMCLock: [
          { id: 'ACTIVE', text: 'Chưa khóa' },
          { id: 'INACTIVE', text: 'Đã khóa trước 31/12/23' },
        ],
        cancelModel: false,
        cancelItem: {
          id: '',
          note: '',
        },
        cancelMess: '',
        changeMonthModel: false,
        changeMonthItemSelect: {},
        changeMonthItem: {
          id: '',
          description: '',
          monthlyKpi: '',
        },
        changeMonthMess: '',
        objMonthlyKpi: {},
        months: [
          'Tháng 1',
          'Tháng 2',
          'Tháng 3',
          'Tháng 4',
          'Tháng 5',
          'Tháng 6',
          'Tháng 7',
          'Tháng 8',
          'Tháng 9',
          'Tháng 10',
          'Tháng 11',
          'Tháng 12',
        ],
        paramsFilter: {
          orderKpiId: '',
          page: 1,
          limit: 20,
          textSearch: '',
          monthlyKpi: '',
          refer: '',
          saleId: '',
        },
        optionType: [
          { id: 'FINAL', text: 'Đã chốt', class: 'type-primary' },
          { id: 'CALCULATED', text: 'Đã tạm tính', class: 'type-success' },
          { id: 'COUNTED', text: 'Được tính', class: 'type-warning' },
          { id: 'CONFLICT', text: 'Xung đột kpi', class: 'type-danger' },
          { id: 'CARRY_OVER', text: 'Chuyển tháng tính kpi', class: 'type-warning' },
          { id: 'CANCEL', text: 'Hủy kpi', class: 'type-danger' },
          { id: 'COMPLETED', text: 'Hoàn thành', class: 'type-primary' },
          { id: 'ERROR', text: 'Tính lỗi', class: 'type-success' },
        ],
        totalKpi: 0,
        userData: JSON.parse(localStorage.getItem('userData')),
        recalculateModel: false,
        recalculateItemSelect: {},
        recalculateItem: {
          id: '',
          reason: '',
        },
        recalculateMess: '',
        optionSaleIds: [],
        optionActionKpi: [
          { code: 'ADD', text: '+' },
          { code: 'MINUS', text: '-' },
        ],
        displayActionFollowType: ['COUNTED', 'CALCULATED', 'CARRY_OVER', 'ERROR', 'CONFLICT'],
        optionTypeContractPackage: Config.typeContractPackage,
      }
    },
    async created() {
      await this.fetchData()
      await this.getListStaff()
    },

    watch: {
      'paramsFilter.page': function () {
        this.fetchData()
      },
      'paramsFilter.limit': function () {
        this.fetchData()
      },
    },

    methods: {
      async fetchData() {
        try {
          this.loading = true
          this.paramsFilter.orderKpiId = this.$route.params.id
          const data = await KpiSaleOrderService.kpiFilterItem(this.paramsFilter)
          if (data.success) {
            this.dataKpiLists = data.data.list
            this.totalKpi = data.data.count
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      joinArrayData(item, options) {
        let strs = []
        options.forEach(obj => {
          if (obj.id == item) {
            strs = obj.text
          }
        })
        return strs
      },
      openCancelModel(item_id) {
        this.cancelModel = true
        this.cancelItem.id = item_id
        this.cancelMess = ''
      },
      async clickCancelKpi() {
        try {
          if (this.cancelItem.id != '' && this.cancelItem.note != '') {
            const data = await KpiSaleOrderService.kpiItemCancel(this.cancelItem)
            if (data.success) {
              await this.fetchData()
            }
          } else {
            this.cancelMess = 'Lý do không được trống.'
          }
        } catch (error) {
          this.cancelMess = error
        } finally {
          this.loading = false
        }
      },
      openChangeMonthModel(item) {
        this.changeMonthModel = true
        this.changeMonthItem.id = item.id
        this.changeMonthItemSelect = item
        this.changeMonthMess = ''
      },
      async clickChangeMonthKpi() {
        try {
          if (
            this.changeMonthItem.id != '' &&
            this.changeMonthItem.description != '' &&
            this.objMonthlyKpi.month != '' &&
            this.objMonthlyKpi.year != '' &&
            this.objMonthlyKpi.month != undefined &&
            this.objMonthlyKpi.year != undefined
          ) {
            let monthIndex = 0
            if (parseInt(this.objMonthlyKpi.monthIndex) < 10) {
              monthIndex = '0' + this.objMonthlyKpi.monthIndex
            }
            this.changeMonthItem.monthlyKpi = monthIndex + '/' + this.objMonthlyKpi.year
            const data = await KpiSaleOrderService.kpiItemChangeMonth(this.changeMonthItem)
            if (data.success) {
              await this.fetchData()
            }
          } else {
            this.changeMonthMess = 'Lý do chuyển không được trống.'
          }
        } catch (error) {
          this.changeMonthMess = error
        } finally {
          this.loading = false
        }
      },
      async submitSearchForm() {
        this.paramsFilter.page = 1
        this.fetchData()
      },
      clearSearch() {
        this.paramsFilter = {
          limit: 20,
          page: 1,
        }
        this.fetchData()
      },
      async getListStaff() {
        try {
          this.loading = true
          if (this.userData.userId) {
            const search = {
              userId: this.userData.userId,
            }
            const data = await StaffService.getListSubordinateV3(search)
            if (data.success) {
              this.optionSaleIds = data.data.map(e => {
                return {
                  id: e.id,
                  text: `${e.name} - ${e.email}`,
                }
              })
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      openRecalculateModel(item) {
        this.recalculateModel = true
        this.recalculateItem.id = item.mcId
        this.recalculateItemSelect = item
        this.recalculateMess = ''
        this.recalculateItem.reason = ''
      },
      async clickRecalculateKpi() {
        try {
          if (this.recalculateItem.reason == '') {
            this.recalculateMess = 'Lý do không được trống.'
            return false
          }
          if (this.recalculateItem.id != '' && this.recalculateItem.reason != '') {
            const params = {
              id: this.recalculateItem.id,
              reason: 'CHANGE_KPI',
              description: this.recalculateItem.reason,
            }
            const data = await KpiSaleOrderService.kpiPushRequestKpi(params)
            if (data.success) {
              await this.fetchData()
              this.recalculateModel = false
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      getDisplayActionKpi(code) {
        const name = this.optionActionKpi.find(item => item.code === code)
        return name ? name.text : code
      },
      getColorType(type) {
        const typeMap = this.optionType.find(item => item.id == type)
        return typeMap ? typeMap.class : ''
      },
    },
  }
</script>
<style scoped>
  .text-red {
    color: red;
  }
  ::v-deep .month-picker__container * {
    font-size: 14px !important;
  }
  ::v-deep .month-picker-input,
  ::v-deep .month-picker-input-container {
    width: 100% !important;
    font-size: 13px !important;
    color: #495057 !important;
  }
  ::v-deep .month-picker__container {
    z-index: 999999;
    width: 210px !important;
  }
  ::v-deep .month-picker__year button:first-child,
  ::v-deep .month-picker__year button:last-child {
    width: 25px !important;
    height: 28px !important;
  }
  ::v-deep .month-picker__year p {
    margin: 8px 0 !important;
  }
  ::v-deep .month-picker__month {
    border: 1px solid #ddd !important;
    border-radius: 0 !important;
    padding: 8px 2px !important;
    text-shadow: none;
  }

  .type-warning {
    color: #fff;
    background-color: #ffc107;
  }
  .type-success {
    color: #fff;
    background-color: #1a9e3f;
  }
  .type-danger {
    color: #fff;
    background-color: #dc3545;
  }
  .type-primary {
    color: #fff;
    background-color: #007bff;
  }
</style>
